export default "__VITE_ASSET__ca1334ec__"